export default __webpack_public_path__ + "static/media/product.2e6b5288.png";